<template>
  <el-container>
    <el-container>
      <el-header>
        <nav-header></nav-header>
      </el-header>
      <el-main>
        <div>
          <h1>我们是您身边的投资顾问，为您的每一次投资提供趋势研判！</h1>
        </div>
      </el-main>
      <el-header>
        <h2>版权归北京买点科技有限责任公司所有</h2>
      </el-header>
    </el-container>
  </el-container>
</template>
<script>
import NavHeader from "@/components/NavHeader.vue";

export default {
  components: { NavHeader }
};
</script>



// WEBPACK FOOTER //
// src/components/AboutUs.vue